/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:01:07
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-14 16:09:36
 */
import req from "@/utils/request";


export const tree = (params) => req.post("/site-service/m/site/column/newTree", params);
export const list = (params) => req.post("/site-service/m/manuscript/selectPage", params);
export const deleteById = (params) => req.post("/site-service/m/manuscript/deleteById", params);
export const offline = (params) => req.post("/site-service/m/manuscript/toColumnOffline", params);
export const selectListById = (params) => req.post("/site-service/m/journal/selectListById", params);
export const release = (params) => req.post("/site-service/m/manuscript/toColumnExamine", params);
export const up = (params) => req.post("/site-service/m/manSort/up", params);
export const down = (params) => req.post("/site-service/m/manSort/down", params);
export const previewOfflineManuscript = (params) => req.post("/front-service/m/previewOfflineManuscript", params);

export const cancelTop = (params) => req.post("/site-service/m/manSort/cancelTop", params);
export const top = (params) => req.post("/site-service/m/manSort/top", params);

export const columnManuscriptBatchCopy = (params) => req.post("/site-service/m/manuscript/columnManuscriptBatchCopy", params);
export const removeColumnManuscript = (params) => req.post("/site-service/m/manuscript/removeColumnManuscript", params);
export const ColumnDetailsDataResponse = (params) => req.post("/site-service/m/site/column/selectColumnDetails", params);
export const columnManuscriptMigrate = (params) => req.post("/site-service/m/manuscript/columnManuscriptMigrate", params);
